import React, { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { getWhatsAppPhone } from '../utils/whatsapp';

// Botão flutuante do WhatsApp — o verde #25D366 é a cor da marca WhatsApp (exceção de terceiros
// do guia de design). Achados: o número estava fixo aqui (agora getWhatsAppPhone(), a mesma fonte
// do resto do site), o keyframe tinha `rotate(0eg)` (inválido) e o foco não usava o anel do tema.
const FloatingWhatsApp: React.FC = () => {
  const [isShaking, setIsShaking] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 1000); // Shakes for 1 second
    }, 30000); // Every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleClick = () => {
    ReactGA.event({
      category: "contact",
      action: "whatsapp_click",
      label: "floating_button"
    });
  };

  const message = encodeURIComponent('Olá! Gostaria de fazer um orçamento com a X Produções.');

  return (
    <>
      <style>
        {`
          @keyframes shake {
            0% { transform: rotate(0deg); }
            25% { transform: rotate(5deg); }
            50% { transform: rotate(0deg); }
            75% { transform: rotate(-5deg); }
            100% { transform: rotate(0deg); }
          }
          .animate-shake {
            animation: shake 0.5s ease-in-out infinite;
          }
        `}
      </style>
      <a
        href={`https://wa.me/${getWhatsAppPhone()}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className={`fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl transition-transform hover:scale-110 hover:bg-[#128C7E] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background ${
          isShaking ? 'animate-shake' : ''
        }`}
        aria-label="Fale conosco no WhatsApp"
      >
        <svg
          className="h-8 w-8"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"
            fillRule="evenodd"
          />
        </svg>
      </a>
    </>
  );
};

export default FloatingWhatsApp;
